<template>
    <!--npm install --save codemirror
    npm install --save sql-formatter-->
    <el-row class="coderStyle" v-loading="loading" element-loading-text="数据准备中...">
        <el-row class="coderMenuStyle">
            <!--字体大小-->
            <el-dropdown v-if="enableFontSize" type="primary"
                         class="buttonStyle"
                         style="width: 80px;margin-top: 10px"
                         size="small"
                         trigger="click"
                         @command="fontSizeChange">
                <div class="buttonBodyStyle">
                    <div class="buttonHover verticalMiddle">
<!--                        <img style="width: 100%;height: 100%" src="..\icons\svg\fontSize.svg" >-->
                        <svg-icon style="width: 100%;height: 100%" icon-class="fontSize"></svg-icon>
                    </div>
                    <div class="verticalMiddle" style="margin-left: 3px">字体大小</div>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="item in fontSizeList"
                                      :command="item"
                                      :key="item">
                        {{item}}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <!-- 字体 -->
            <el-dropdown v-if="enableFontFamily" type="primary"
                         class="buttonStyle"
                         style="width: 50px;margin-top: 10px"
                         size="small"
                         trigger="click"
                         @command="fontChange">
                <div class="buttonBodyStyle">
                    <div class="buttonHover verticalMiddle">
                        <svg-icon style="width: 100%;height: 100%" icon-class="font"></svg-icon>
                    </div>
                    <div class="verticalMiddle" style="margin-left: 3px">字体</div>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in fontSupportList"
                                      :command="item.value"
                                      :key="index">
                        {{item.label}}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <!-- 主题 -->
            <el-dropdown v-if="enableTheme" type="primary"
                         class="buttonStyle"
                         style="width: 80px;margin-top: 10px"
                         size="small"
                         trigger="click"
                         @command="themeChange">
                <div class="buttonBodyStyle">
                    <div class="buttonHover verticalMiddle">
<!--                        <img style="width: 100%;height: 100%" src="..\icons\svg\theme.svg" >-->
                        <svg-icon style="width: 100%;height: 100%" icon-class="theme"></svg-icon>
                    </div>
                    <div class="verticalMiddle" style="margin-left: 3px">主题切换</div>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="item in themeList"
                                      :command="item.value"
                                      :key="item.label">
                        {{item.label}}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <!-- sql格式化 -->
            <el-button  v-if="enableFormat" class="buttonStyle" size="small" type="text" @click="formatClickHandler">
                <div class="buttonBodyStyle">
                    <div class="buttonHover verticalMiddle">
<!--                        <img style="width: 100%;height: 100%" src="..\icons\svg\format.svg" >-->
                        <svg-icon style="width: 100%;height: 100%" icon-class="format"></svg-icon>
                    </div>
                    <div class="verticalMiddle" style="margin-left: 3px">格式化</div>
                </div>
            </el-button>
            <!-- 执行 -->
            <el-button v-if="enablePerform" class="buttonStyle" size="small" type="text" @click="executeSql">
                <div class="buttonBodyStyle">
                    <div class="buttonHover verticalMiddle">
<!--                        <img style="width: 100%;height: 100%" src="..\icons\svg\execute.svg" >-->
                        <svg-icon style="width: 100%;height: 100%" icon-class="execute"></svg-icon>
                    </div>
                    <div class="verticalMiddle" style="margin-left: 3px">执行</div>
                </div>
            </el-button>
        </el-row>
        <el-row class="coderContentStyle" :style="contentStyle">
            <textarea ref="myCode"></textarea>
        </el-row>
    </el-row>
</template>

<script>
    import 'codemirror/theme/idea.css';
    import 'codemirror/theme/ambiance.css';
    import 'codemirror/theme/base16-light.css';
    import 'codemirror/theme/eclipse.css';
    import 'codemirror/lib/codemirror.css';
    import 'codemirror/addon/hint/show-hint.css';
    import sqlFormatter from 'sql-formatter';
    import IconSvg from "./SvgIcon/index";
    const CodeMirror = require('codemirror/lib/codemirror');
    require('codemirror/mode/sql/sql');
    require('codemirror/addon/hint/show-hint');
    require('codemirror/addon/hint/sql-hint');

    export default {
        name: "Coder",
        components: {IconSvg},
        props: {
            // 默认字号
            fontSize: {
                type: String,
                default: '15px'
            },
            // 默认主题
            theme: {
                type: String,
                default: 'idea'
            },
            // 是否sql
            isSql: {
                type: Boolean,
                default: true
            },
            // 默认字体
            fontFamily: {
                type: String,
                default: 'serif'
            },
            // 自定义提示 格式{ 提示值: [提示值的下级提示值（如：提示值.user）] }
            customAutoComplete: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            // 编辑器的内容 必须使用.sync
            code: {
                type: String,
                required: true
            },
            width: {
                type: String,
                default: '100%'
            },
            height: {
                type: String,
                default: '300px'
            },
            //
            menuList: {
                type: Array,
                default: () => {
                    return ['fontSize','fontFamily','theme','format','perform']
                }
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data:function () {
            return {
                sqlCode: '',
                coder: undefined,
                contentStyle: {
                    fontSize: this.fontSize,
                    height: this.height,
                    width: this.width,
                    fontFamily: this.fontFamily
                },
                // 主题列表
                themeList: [
                    {label: 'idea', value: 'idea'},
                    {label: 'eclipse', value: 'eclipse'},
                    {label: '深色', value: 'ambiance'},
                    {label: '亮色', value: 'base16-light'},
                ],
                // 字体大小列表
                fontSizeList: [
                    12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30
                ],
                // 支持字体列表
                fontSupportList: [],
                coderOption: {
                    // 选择对应代码编辑器的语言
                    mode: 'text/x-mysql',
                    // 初始值
                    theme: this.theme,
                    // indentWithTabs: true,
                    smartIndent: true,
                    // 是否显示行号
                    lineNumbers: true,
                    value: '',
                    matchBrackets: true,
                    extraKeys: { 'Alt': 'autocomplete' }, // 自定义快捷键
                    hintOptions: {
                        // 自定义提示选项
                        tables: this.customAutoComplete,
                        // 单个提示项是否自动选择
                        completeSingle: false,
                        hint: this.hintFun,
                        // 是否在光标离开时关闭提示
                        closeOnUnfocus: true
                    }
                },
                // 单词正则
                regex: new RegExp(/[a-zA-Z0-9_\u4e00-\u9fa5]/)
            }
        },
        methods: {
            // sql 格式化
            formatClickHandler: function () {
                let value = this.coder.getValue();
                let formatted = sqlFormatter.format(value);
                this.coder.setValue(formatted);
            },
            initialization: function () {
                this.coder = CodeMirror.fromTextArea(this.$refs.myCode, this.coderOption);
                // 输入或粘贴时触发
                this.coder.on('inputRead', (instance, changeObj) => {
                    // 过滤掉空格回车等输入
                    if (!/\s/.test(changeObj.text[0])) {
                        this.coder.showHint()
                    }
                });
                // 编辑器内容改变时触发
                this.coder.on('change', (ele, data) => {
                    this.sqlCode = ele.getValue();
                })
                this.coder.setValue(this.code);
            },
            // 主题变更
            themeChange: function (nv) {
                this.coder.setOption('theme', nv);
            },
            // 字体大小改变
            fontSizeChange: function (nv) {
                this.contentStyle.fontSize = nv + 'px';
            },
            // 字体改变
            fontChange: function (nv) {
                this.contentStyle.fontFamily = nv;
            },
            // 获取支持的字体
            fontCheck: function () {
                this.fontSupportList = getSupportFont();
            },
            // 点击预览执行
            executeSql: function () {
                this.$emit('executeSql', this.sqlCode);
            },
            include: function(array, target) {
                let filter = array.filter(val => {
                    return val.toUpperCase() === target;
                });
                return filter.length > 0;
            },
            // 自定义提示获取方法
            hintFun: function (coder, arg2) {
                // 获取光标对象
                let cursor = coder.getCursor();
                // 获取当前行内容
                let line = coder.getLine(cursor.line).toUpperCase();
                // 获取当前光标位置
                let start = cursor.ch
                let end = cursor.ch
                let regex = this.regex;
                // 获取光标前的字符串
                line = line.substr(0, start);
                let match;
                // 找到单词起始位置
                while (start && (match = regex.exec(line.charAt(start - 1))) !== null) {
                    start --;
                }
                line = line.substr(start, line.length);
                // console.log(line);
                // 获取提示列表
                // {
                //     text: '88888', 实际值
                //     displayText: '6666',  显示值
                //     type: 'TABLE',
                //     render: myRender  dom生成方法，即item
                // }
                if (line.includes('.')) {
                    // CodeMirror 提供的sql提示过滤器
                    let sql = CodeMirror.hint.sql(coder, arg2);
                    return sql;
                } else {
                    let additionOption = [];
                    let allOption = arg2.tables;
                    let keys = Object.keys(allOption);
                    for (let i = 0; i < keys.length; i++) {
                        let array = allOption[keys[i]];
                        // 匹配表/视图名
                        if (keys[i].toUpperCase().startsWith(line)) {
                            additionOption.push({
                                displayText: keys[i] + '  (TABLE/VIEW)',
                                text: keys[i],
                                type: 'TABLE/VIEW',
                            })
                        }
                        // 匹配字段
                        for (let j = 0; j < array.length; j++) {
                            if (array[j].toUpperCase().startsWith(line)) {
                                additionOption.push({
                                    displayText: keys[i] + '.' + array[j] + '  (COLUMN)',
                                    text: array[j],
                                    type: 'COLUMN',
                                })
                            }
                        }
                    }
                    arg2.tables = {};
                    // console.log(line, otherOption);
                    let sql = CodeMirror.hint.sql(coder, arg2);
                    arg2.tables = allOption;
                    sql.list = sql.list.concat(additionOption);
                    // console.log(sql);
                    return sql;
                }
            },
            setValue: function (val) {
                this.coder.setValue(val);
            }
        },
        watch: {
            sqlCode: function (nv, ov) {
                this.$emit('update:code', nv);
            },
            code: function (nv, ov) {
                if (nv !== this.sqlCode) {
                    this.setValue(nv);
                }
                this.sqlCode = nv;
            },
            customAutoComplete: {
                handler: function (nv, ov) {
                    let context = this;
                    let opt = {
                        // 自定义提示选项
                        tables: nv,
                        // 单个提示项是否自动选择
                        completeSingle: false,
                        // 获取提示的方法
                        hint: this.hintFun,
                        // 是否在光标离开时关闭提示
                        closeOnUnfocus: true
                    }
                    this.coder.setOption('hintOptions', opt);
                },
                deep: true
            }
        },
        computed: {
            enableFormat: function () {
                return this.include(this. menuList, 'FORMAT');
            },
            enableFontSize: function () {
                return this.include(this. menuList, 'FONTSIZE');
            },
            enableFontFamily: function () {
                return this.include(this. menuList, 'FONTFAMILY');
            },
            enablePerform: function () {
                return this.include(this. menuList, 'PERFORM');
            },
            enableTheme: function () {
                return this.include(this. menuList, 'THEME');
            },
        },
        mounted() {
            this.initialization();
            this.fontCheck();
        }
    }

    /** 自定义提示DOM */
    function myRender (ele, self, data) {
        let divElement = document.createElement('div');
        divElement.style.width = '200px';
        divElement.style.height = '25px';
        divElement.style.lineHeight = '25px'
        let img;
        if (data.type === 'TABLE') {
            img = table;
        } else if (data.type === 'VIEW') {
            img = view;
        } else if (data.type === 'COLUMN') {
            img = column;
        } else {
            img = undefined;
        }
        if (img === undefined) {
            divElement.innerHTML = '<div style="width: 100%;height: 100%;">' +
                '<div style="float: left;margin-left: 20px"><span style="height: 100%">' + data.text + '</span></div>' +
                '</div>'
        } else {
            divElement.innerHTML = '<div style="width: 100%;height: 100%;">' +
                '<div style="float: left"><img style="width: 20px;height: 25px" src="' + img +' "/></div>' +
                '<div style="float: left"><span style="height: 100%">' + data.text + '</span></div>' +
                '</div>'
        }

        ele.appendChild(divElement);
    }

    // 支持字体缓存
    let supportFontList = undefined;
    // 获取浏览器支持的字体
    function getSupportFont() {
        if (supportFontList !== undefined) {
            return supportFontList;
        }
        // 受测字体集合
        let fontListAll = {
            base: [
                {ch: '基础字体1', en: 'monospace'},
                {ch: '基础字体2', en: 'sans-serif'},
                {ch: '基础字体3', en: 'serif'},
            ],
            windows: [{
                ch: '宋体',
                en: 'SimSun'
            }, {
                ch: '黑体',
                en: 'SimHei'
            }, {
                ch: '微软雅黑',
                en: 'Microsoft Yahei'
            }, {
                ch: '微软正黑体',
                en: 'Microsoft JhengHei'
            }, {
                ch: '楷体',
                en: 'KaiTi'
            }, {
                ch: '新宋体',
                en: 'NSimSun'
            }, {
                ch: '仿宋',
                en: 'FangSong'
            }],
            'OS X': [{
                ch: '苹方',
                en: 'PingFang SC'
            }, {
                ch: '华文黑体',
                en: 'STHeiti'
            }, {
                ch: '华文楷体',
                en: 'STKaiti'
            }, {
                ch: '华文宋体',
                en: 'STSong'
            }, {
                ch: '华文仿宋',
                en: 'STFangsong'
            }, {
                ch: '华文中宋',
                en: 'STZhongsong'
            }, {
                ch: '华文琥珀',
                en: 'STHupo'
            }, {
                ch: '华文新魏',
                en: 'STXinwei'
            }, {
                ch: '华文隶书',
                en: 'STLiti'
            }, {
                ch: '华文行楷',
                en: 'STXingkai'
            }, {
                ch: '冬青黑体简',
                en: 'Hiragino Sans GB'
            }, {
                ch: '兰亭黑-简',
                en: 'Lantinghei SC'
            }, {
                ch: '翩翩体-简',
                en: 'Hanzipen SC'
            }, {
                ch: '手札体-简',
                en: 'Hannotate SC'
            }, {
                ch: '宋体-简',
                en: 'Songti SC'
            }, {
                ch: '娃娃体-简',
                en: 'Wawati SC'
            }, {
                ch: '魏碑-简',
                en: 'Weibei SC'
            }, {
                ch: '行楷-简',
                en: 'Xingkai SC'
            }, {
                ch: '雅痞-简',
                en: 'Yapi SC'
            }, {
                ch: '圆体-简',
                en: 'Yuanti SC'
            }],
            'office': [{
                ch: '幼圆',
                en: 'YouYuan'
            }, {
                ch: '隶书',
                en: 'LiSu'
            }, {
                ch: '华文细黑',
                en: 'STXihei'
            }, {
                ch: '华文楷体',
                en: 'STKaiti'
            }, {
                ch: '华文宋体',
                en: 'STSong'
            }, {
                ch: '华文仿宋',
                en: 'STFangsong'
            }, {
                ch: '华文中宋',
                en: 'STZhongsong'
            }, {
                ch: '华文彩云',
                en: 'STCaiyun'
            }, {
                ch: '华文琥珀',
                en: 'STHupo'
            }, {
                ch: '华文新魏',
                en: 'STXinwei'
            }, {
                ch: '华文隶书',
                en: 'STLiti'
            }, {
                ch: '华文行楷',
                en: 'STXingkai'
            }, {
                ch: '方正舒体',
                en: 'FZShuTi'
            }, {
                ch: '方正姚体',
                en: 'FZYaoti'
            }],
            'open': [{
                ch: '思源黑体',
                en: 'Source Han Sans CN'
            }, {
                ch: '思源宋体',
                en: 'Source Han Serif SC'
            }, {
                ch: '文泉驿微米黑',
                en: 'WenQuanYi Micro Hei'
            }],
            'hanyi': [{
                ch: '汉仪旗黑',
                en: 'HYQihei 40S'
            }, {
                ch: '汉仪旗黑',
                en: 'HYQihei 50S'
            }, {
                ch: '汉仪旗黑',
                en: 'HYQihei 60S'
            }, {
                ch: '汉仪大宋简',
                en: 'HYDaSongJ'
            }, {
                ch: '汉仪楷体',
                en: 'HYKaiti'
            }, {
                ch: '汉仪家书简',
                en: 'HYJiaShuJ'
            }, {
                ch: '汉仪PP体简',
                en: 'HYPPTiJ'
            }, {
                ch: '汉仪乐喵体简',
                en: 'HYLeMiaoTi'
            }, {
                ch: '汉仪小麦体',
                en: 'HYXiaoMaiTiJ'
            }, {
                ch: '汉仪程行体',
                en: 'HYChengXingJ'
            }, {
                ch: '汉仪黑荔枝',
                en: 'HYHeiLiZhiTiJ'
            }, {
                ch: '汉仪雅酷黑W',
                en: 'HYYaKuHeiW'
            }, {
                ch: '汉仪大黑简',
                en: 'HYDaHeiJ'
            }, {
                ch: '汉仪尚魏手书W',
                en: 'HYShangWeiShouShuW'
            }],
            'fangzheng': [{
                ch: "方正粗雅宋简体",
                en: "FZYaSongS-B-GB"
            }, {
                ch: "方正报宋简体",
                en: "FZBaoSong-Z04S"
            }, {
                ch: "方正粗圆简体",
                en: "FZCuYuan-M03S"
            }, {
                ch: "方正大标宋简体",
                en: "FZDaBiaoSong-B06S"
            }, {
                ch: "方正大黑简体",
                en: "FZDaHei-B02S"
            }, {
                ch: "方正仿宋简体",
                en: "FZFangSong-Z02S"
            }, {
                ch: "方正黑体简体",
                en: "FZHei-B01S"
            }, {
                ch: "方正琥珀简体",
                en: "FZHuPo-M04S"
            }, {
                ch: "方正楷体简体",
                en: "FZKai-Z03S"
            }, {
                ch: "方正隶变简体",
                en: "FZLiBian-S02S"
            }, {
                ch: "方正隶书简体",
                en: "FZLiShu-S01S"
            }, {
                ch: "方正美黑简体",
                en: "FZMeiHei-M07S"
            }, {
                ch: "方正书宋简体",
                en: "FZShuSong-Z01S"
            }, {
                ch: "方正舒体简体",
                en: "FZShuTi-S05S"
            }, {
                ch: "方正水柱简体",
                en: "FZShuiZhu-M08S"
            }, {
                ch: "方正宋黑简体",
                en: "FZSongHei-B07S"
            }, {
                ch: "方正宋三简体",
                en: "FZSong"
            }, {
                ch: "方正魏碑简体",
                en: "FZWeiBei-S03S"
            }, {
                ch: "方正细等线简体",
                en: "FZXiDengXian-Z06S"
            }, {
                ch: "方正细黑一简体",
                en: "FZXiHei I-Z08S"
            }, {
                ch: "方正细圆简体",
                en: "FZXiYuan-M01S"
            }, {
                ch: "方正小标宋简体",
                en: "FZXiaoBiaoSong-B05S"
            }, {
                ch: "方正行楷简体",
                en: "FZXingKai-S04S"
            }, {
                ch: "方正姚体简体",
                en: "FZYaoTi-M06S"
            }, {
                ch: "方正中等线简体",
                en: "FZZhongDengXian-Z07S"
            }, {
                ch: "方正准圆简体",
                en: "FZZhunYuan-M02S"
            }, {
                ch: "方正综艺简体",
                en: "FZZongYi-M05S"
            }, {
                ch: "方正彩云简体",
                en: "FZCaiYun-M09S"
            }, {
                ch: "方正隶二简体",
                en: "FZLiShu II-S06S"
            }, {
                ch: "方正康体简体",
                en: "FZKangTi-S07S"
            }, {
                ch: "方正超粗黑简体",
                en: "FZChaoCuHei-M10S"
            }, {
                ch: "方正新报宋简体",
                en: "FZNew BaoSong-Z12S"
            }, {
                ch: "方正新舒体简体",
                en: "FZNew ShuTi-S08S"
            }, {
                ch: "方正黄草简体",
                en: "FZHuangCao-S09S"
            }, {
                ch: "方正少儿简体",
                en: "FZShaoEr-M11S"
            }, {
                ch: "方正稚艺简体",
                en: "FZZhiYi-M12S"
            }, {
                ch: "方正细珊瑚简体",
                en: "FZXiShanHu-M13S"
            }, {
                ch: "方正粗宋简体",
                en: "FZCuSong-B09S"
            }, {
                ch: "方正平和简体",
                en: "FZPingHe-S11S"
            }, {
                ch: "方正华隶简体",
                en: "FZHuaLi-M14S"
            }, {
                ch: "方正瘦金书简体",
                en: "FZShouJinShu-S10S"
            }, {
                ch: "方正细倩简体",
                en: "FZXiQian-M15S"
            }, {
                ch: "方正中倩简体",
                en: "FZZhongQian-M16S"
            }, {
                ch: "方正粗倩简体",
                en: "FZCuQian-M17S"
            }, {
                ch: "方正胖娃简体",
                en: "FZPangWa-M18S"
            }, {
                ch: "方正宋一简体",
                en: "FZSongYi-Z13S"
            }, {
                ch: "方正剪纸简体",
                en: "FZJianZhi-M23S"
            }, {
                ch: "方正流行体简体",
                en: "FZLiuXingTi-M26S"
            }, {
                ch: "方正祥隶简体",
                en: "FZXiangLi-S17S"
            }, {
                ch: "方正粗活意简体",
                en: "FZCuHuoYi-M25S"
            }, {
                ch: "方正胖头鱼简体",
                en: "FZPangTouYu-M24S"
            }, {ch: "方正铁筋隶书简体", en: "FZTieJinLiShu-Z14S"}, {ch: "方正北魏楷书简体", en: "FZBeiWeiKaiShu-Z15S"}, {
                ch: "方正卡通简体",
                en: "FZKaTong-M19S"
            }, {
                ch: "方正艺黑简体",
                en: "FZYiHei-M20S"
            }, {
                ch: "方正水黑简体",
                en: "FZShuiHei-M21S"
            }, {
                ch: "方正古隶简体",
                en: "FZGuLi-S12S"
            }, {
                ch: "方正幼线简体",
                en: "FZYouXian-Z09S"
            }, {
                ch: "方正启体简体",
                en: "FZQiTi-S14S"
            }, {
                ch: "方正小篆体",
                en: "FZXiaoZhuanTi-S13T"
            }, {
                ch: "方正硬笔楷书简体",
                en: "FZYingBiKaiShu-S15S"
            }, {
                ch: "方正毡笔黑简体",
                en: "FZZhanBiHei-M22S"
            }, {
                ch: "方正硬笔行书简体",
                en: "FZYingBiXingShu-S16S"
            }]
        };
        // 字体检测器
        let fontChecker = function () {
            // 基础字体
            let baseFonts = ['monospace', 'sans-serif', 'serif'];
            let testString = "abcdefjhijklmnopqrstuvwxyz123456789!@#$%^&*()_+-[]{}|';:?/.,<>*.";
            let testSize = '72px';
            let body = document.getElementsByTagName("body")[0];
            let span = document.createElement('span');
            let baseFontHeight = {};
            let baseFontWidth = {};
            span.style.fontSize = testSize;
            span.innerHTML = testString;

            for (let i = 0; i < baseFonts.length; i++) {
                span.style.fontFamily = baseFonts[i];
                body.appendChild(span);
                baseFontHeight[baseFonts[i]] = span.offsetHeight;
                baseFontWidth[baseFonts[i]] = span.offsetWidth;
                body.removeChild(span);
            }

            // 若浏览器支支持该字体，返回true 否则返回false
            function check(font) {
                if (baseFonts.indexOf(font) > -1) {
                    return true;
                }
                let flag = false;
                for (let i = 0; i < baseFonts.length && !flag; i++) {
                    span.style.fontFamily = font + ',' + baseFonts[i];
                    body.appendChild(span);
                    flag = flag || (span.offsetWidth !==  baseFontWidth[baseFonts[i]] || span.offsetHeight !==  baseFontHeight[baseFonts[i]]);
                    body.removeChild(span);
                }
                return flag;
            }

            return check;
        };

        let keys = Object.keys(fontListAll);
        let checker = fontChecker();
        let res = [];
        for (let i = 0; i < keys.length; i++) {
            let fontList = fontListAll[keys[i]];
            for (let j = 0; j < fontList.length; j++) {
                if (checker(fontList[j].en)) {
                    res.push({
                        label: fontList[j].ch,
                        value: fontList[j].en,
                    })
                } else if (checker(fontList[j].ch)) {
                    res.push({
                        label: fontList[j].ch,
                        value: fontList[j].ch,
                    })
                }
            }
        }
        supportFontList = res;
        return res;
    }

</script>

<style scoped>
    .buttonBodyStyle {
        width: 100%;
        height: 20px;
        font-size: 15px;
        line-height: normal;
    }
    .buttonHover {
        width: 15px;
        height: 15px;
    }
    .buttonStyle {
        float: right;
        margin: 0px 20px 0px 20px;
        color: #c6c6c6;
        cursor: pointer;
    }
    .verticalMiddle {
        vertical-align: middle;
        display: inline-block;
        color: #c6c6c6;
    }
    .coderStyle {
        width: 100%;
        height: 100%;
        border: 2px solid #9d9b99;
        border-radius: 4px;
    }
    .coderMenuStyle {
        background: rgba(25, 34, 57, 0.84);
        border-bottom: 1px solid #40c3ff;
        height: 40px;
    }
    .coderContentStyle {
        line-height: normal;
    }
    .middleHelp {
        display: inline-block;
        vertical-align: middle;
        height: 100%;
        width: 0%;
    }
</style>
<style>
    .CodeMirror {
        height: 100%;
        /*width: 100%;*/
        font-family: unset;
        z-index: 1000;
    }
    .CodeMirror-hints {
        z-index: 9999;
    }
</style>
